import { API } from "aws-amplify";
import { addIG, addRG, addUC } from "../config/actions";

export const types = {
  sendDataForPdf: "SEND_DATA_FOR_PDF",
  updateDataForPdf: "UPDATE_DATA_FOR_PDF",
  cleanDataTable: "CLEAN_DATA_TABLE",
  updateBtnPdf: "UPDATE_BTN_PDF",
  sendDataForPdfRI: "SEND_DATA_FOR_PDF_RI",
  updateDataForPdfRI: "UPDATE_DATA_FOR_PDF_RI",
  cleanDataTableRI: "CLEAN_DATA_TABLE_RI",
  updateBtnPdfRI: "UPDATE_BTN_PDF_RI",
  sendDataForPdfVAS: "SEND_DATA_FOR_PDF_VAS",
  updateDataForPdfVAS: "UPDATE_DATA_FOR_PDF_VAS",
  selectResponseVAS: "SELECT_RESPONSE_VAS",
  cleanDataTableVAS: "CLEAN_DATA_TABLE_VAS",
  updateBtnPdfVAS: "UPDATE_BTN_PDF_VAS",
  saveSimulates: 'SAVE_SIMULATES',
  saveConfigProduct: 'SAVE_CONFIG_PRODUCT',
  cleanConfigProduct: 'CLEAN_CONFIG_PRODUCT',
  selectResponseIG: "SELECT_RESPONSE_IG",
  sendDataForPdfIG: "SEND_DATA_FOR_PDF_IG",
  cleanDataTableIG: "CLEAN_DATA_TABLE_IG",
  updateDataForPdfIG: "UPDATE_DATA_FOR_PDF_IG",
  updateBtnPdfIG: "UPDATE_BTN_PDF_IG",
  selectResponseUC: "SELECT_RESPONSE_UC",
  sendDataForPdfUC: "SEND_DATA_FOR_PDF_UC",
  cleanDataTableUC: "CLEAN_DATA_TABLE_UC",
  updateDataForPdfUC: "UPDATE_DATA_FOR_PDF_UC",
  updateBtnPdfUC: "UPDATE_BTN_PDF_UC",
  updateShowSisco: 'showSISCO_STATE'
}


export const sendDataForPdf = (data) => {
  return {
    type: types.sendDataForPdf,
    data
  }
}

export const updateDataForPdf = (updateData) => {
  return {
    type: types.updateDataForPdf,
    updateData
  }
}


export const cleanTablePdf = () => {
  return {
    type: types.cleanDataTable
  }
}

export const updateBtnPdf = (btnPdf) => {
  return {
    type: types.updateBtnPdf,
    btnPdf
  }
}

export const sendDataForPdfRI = (dataRI) => {
  return {
    type: types.sendDataForPdfRI,
    dataRI
  }
}

export const updateDataForPdfRI = (updateDataRI) => {
  return {
    type: types.updateDataForPdfRI,
    updateDataRI
  }
}

export const cleanTablePdfRI = () => {
  return {
    type: types.cleanDataTableRI
  }
}

export const updateBtnPdfRI = (btnPdfRI) => {
  return {
    type: types.updateBtnPdfRI,
    btnPdfRI
  }
}

export const sendDataForPdfVAS = (dataVAS) => {
  return {
    type: types.sendDataForPdfVAS,
    dataVAS
  }
}

export const updateDataForPdfVAS = (updateDataVAS) => {
  return {
    type: types.updateDataForPdfVAS,
    updateDataVAS
  }
}

export const cleanTablePdfVAS = () => {
  return {
    type: types.cleanDataTableVAS
  }
}

export const updateBtnPdfVAS = (btnPdfVAS) => {
  return {
    type: types.updateBtnPdfVAS,
    btnPdfVAS
  }
}

export const selectResponseVAS = (responseVAS) => {
  return {
    type: types.selectResponseVAS,
    responseVAS
  }
}

export const sendDataForPdfIG = (dataIG) => {
  return {
    type: types.sendDataForPdfIG,
    dataIG
  }
}

export const selectResponseIG = (responseIG) => {
  return {
    type: types.selectResponseIG,
    responseIG
  }
}

export const cleanTablePdfIG = () => {
  return {
    type: types.cleanDataTableIG
  }
}

export const updateDataForPdfIG = (updateDataIG) => {
  return {
    type: types.updateDataForPdfIG,
    updateDataIG
  }
}

export const updateBtnPdfIG = (btnPdfIG) => {
  return {
    type: types.updateBtnPdfIG,
    btnPdfIG
  }
}

export const sendDataForPdfUC = (dataUC) => {
  return {
    type: types.sendDataForPdfUC,
    dataUC
  }
}

export const selectResponseUC = (responseUC) => {
  return {
    type: types.selectResponseUC,
    responseUC
  }
}

export const cleanTablePdfUC = () => {
  return {
    type: types.cleanDataTableUC
  }
}

export const updateDataForPdfUC = (updateDataUC) => {
  return {
    type: types.updateDataForPdfUC,
    updateDataUC
  }
}

export const updateBtnPdfUC = (btnPdfUC) => {
  return {
    type: types.updateBtnPdfUC,
    btnPdfUC
  }
}

export const updateShowSisco = (showSISCO) => {
  return {
    type: types.updateShowSisco,
    showSISCO
  }
}

export const saveSimulates = (simulates) => {
  return {
    type: types.saveSimulates,
    simulates
  }
}

export const saveConfigProduct = (portafolio) => {
  return {
    type: types.saveConfigProduct,
    portafolio
  }
}

export const cleanConfigProduct = () => {
  return {
    type: types.cleanConfigProduct
  }
}

export const getConfigProduct = () => {
  return async (dispatch) => {
    try {
      let responseSimulate = await API.get(
        "api-rentas",
        "/producto/configmin/RI"
      );
      dispatch(saveConfigProduct(responseSimulate))
    } catch (e) {
      console.log(e)
    }
  }
}

export const getConfigProductIG = () => {
  return async (dispatch) => {
    try {
      let response = await API.get(
        "api-rentas",
        "/producto/configmin/IG"
      );
      if (response) dispatch(addIG(response));

    } catch (e) {
      console.log(e)
    }
  }
}

export const getConfigProductUC = () => {
  return async (dispatch) => {
    try {
      let response = await API.get(
        "api-rentas",
        "/producto/configmin/UC"
      );
      if (response) dispatch(addUC(response));

    } catch (e) {
      console.log(e)
    }
  }
}

export const getConfigProductRG = () => {
  return async (dispatch) => {
    try {
      let response = await API.get(
        "api-rentas",
        "/producto/configmin/RG"
      );
      if (response) dispatch(addRG(response));

    } catch (e) {
      console.log(e)
    }
  }
}